import React from "react";
import logo from "../assets/images/logo.svg";
import { Link, useHistory } from "react-router-dom";
import "./Header.css";
import { useState,useEffect } from "react";
import UserLogin from "./UserLogin";
import { useUserAuth } from "../context/UserAuthContext";
export default function Header() {
  let history = useHistory();
  const { user } = useUserAuth();
  const handleClick = () => {
    history.push("/");
  };
  return (
    <div className="header-container">
      <div className="header-left">
        <ul>
          <li>
            <img src={logo} alt="#" onClick={handleClick} />
          </li>
          <li>
            <Link
              style={{ textDecoration: "none", color: "rgb(84, 97, 108)" }}
              to="/"
            >
              How to use
            </Link>
          </li>
          <li>
            <Link
              style={{ textDecoration: "none", color: "rgb(84, 97, 108)" }}
              to="/tools"
            >
              Tool&API
            </Link>
          </li>
          <li>
            <Link
              style={{ textDecoration: "none", color: "rgb(84, 97, 108)" }}
              to="/pricing"
            >
              Pricing
            </Link>
          </li>
        </ul>
      </div>

      <div className="header-right">
        <button
          onClick={() => {
            history.push("/upload");
          }}
        >
          Remove Background
        </button>

        {user ? (
          <UserLogin  />
        ) : (
          <button
            className="sign-in-btn"
            onClick={() => {
              history.push("/login");
            }}
          >
            Login / Sign in
          </button>
        )}
      </div>
    </div>
  );
}
